import React, {Component} from 'react';
import axios from 'axios';
import { ThemeProvider } from 'styled-components';
import { THEME } from './constants/theme';
import { GlobalStyle } from './components/styles/GlobalStyle';
import Nav from './components/Nav';
import Reviews from './components/Reviews';
import './css/font-face.css'

const INCREMENT = 10
const REVIEWS_URL = process.env.NODE_ENV === 'production'
  ? 'https://osb.lexus.nl/review/'
  : 'https://acc-osb.lexus.nl/review/'

class App extends Component {
  state = {
    amount: INCREMENT,
    fetched: false,
    fetching: false,
    error: false,
    reviews: []
  }

  componentDidMount() {
    this.fetchReviews();
  }

  fetchReviews = () => {
    this.setState({ fetching: true })
    axios
      .get(`${REVIEWS_URL}dealer/${this.props.dealerid}`)
      .then(res => res.data)
      .then(reviews => this.setState({ reviews, fetching: false, fetched: true }))
      .catch(error => this.setState({ fetching: false, error }))
  }

  showMore = () => this.setState(state => ({ amount: state.amount + INCREMENT}));

  render() {
    const { amount, reviews, fetching, fetched, error } = this.state
    return (
      <ThemeProvider theme={THEME}>
        <>
          <GlobalStyle />
          <Nav total={reviews.length} amount={reviews.length ? amount : 0} />
          <Reviews fetching={fetching} fetched={fetched} error={error} reviews={reviews} total={reviews.length} amount={amount} showMore={this.showMore}/>
        </>
      </ThemeProvider>
    )
  }
}

export default App;
